import { NgModule } from '@angular/core';
import { ReportComponent } from './report.component';

@NgModule({
  declarations: [ReportComponent],
  exports: [ReportComponent],
})
export class ReportModule { }
